import * as React from 'react';
import { observer } from 'mobx-react';

import { ErrorBoundary } from 'bernie-view';
import { Viewport, ViewMedium, ViewSmall } from '@shared-ui/viewport-context';

import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkHeading, UitkText } from 'uitk-react-text';

import { UniversalFilterPills } from './smart-universal-filter-pills';
import { useStores } from 'utility/hooks';
import { ErrorBoundaryLabel } from 'utility';

const FilterPillsSpacingProps: UitkSpacingProps = {
  margin: { blockend: 'four' }
};

const FilterPillsMobSpacingProps: UitkSpacingProps = {
  margin: { blockend: 'six' }
};

const ListingsHeading = () => {
  const { flightsSearchMetadataStore } = useStores();

  return (
    <>
      {flightsSearchMetadataStore && (
        <UitkLayoutFlexItem minWidth="zero" grow={1}>
          <UitkSpacing margin={FilterPillsSpacingProps.margin}>
            <div>
              <UitkHeading tag="h2" size={5}>
                {flightsSearchMetadataStore.primary}
              </UitkHeading>
              <UitkText size={100} spacing="two">
                {flightsSearchMetadataStore.secondary}
              </UitkText>
            </div>
          </UitkSpacing>
        </UitkLayoutFlexItem>
      )}
    </>
  );
};

export const ListingsHeaderBar = observer(function ListingsHeaderBar() {
  const { listingsStore } = useStores();

  return (
    <>
      {listingsStore.smartShoppingShowFlexAndFilters && (
        <ErrorBoundary label={ErrorBoundaryLabel.SMART_SHOPPING_HEADER}>
          <Viewport>
            <ViewSmall>
              <UitkLayoutFlex alignItems="center" wrap="wrap">
                <ListingsHeading />
                <UitkLayoutFlexItem>
                  <UitkSpacing margin={FilterPillsMobSpacingProps.margin}>
                    <div>
                      <UniversalFilterPills />
                    </div>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </ViewSmall>
            <ViewMedium>
              <UitkLayoutFlex alignItems="center" space="six" wrap="wrap">
                <ListingsHeading />
                <UitkLayoutFlexItem>
                  <UitkSpacing margin={FilterPillsSpacingProps.margin}>
                    <div>
                      <UniversalFilterPills />
                    </div>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </ViewMedium>
          </Viewport>
        </ErrorBoundary>
      )}
    </>
  );
});
